/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesHr = {
  privacy: {
    pageTitle: "Politika privatnosti",
    lastUpdated: "Posljednje ažuriranje: 1. lipnja 2026.",
    introduction: {
      title: "Uvod",
      body: "WasOK je lokalno orijentirana aplikacija za pomoć pri kupovini, osmišljena kako bi korisnicima pomogla zapamtiti proizvode koje su prethodno kupili, ocijenili ili recenzirali.\n\nOva politika privatnosti objašnjava koje se informacije obrađuju pri korištenju aplikacije, kako se podaci pohranjuju te kako određene usluge trećih strana mogu funkcionirati.",
    },
    dataStored: {
      title: "Podaci koje aplikacija pohranjuje",
      body: "WasOK lokalno na vašem uređaju pohranjuje sljedeće informacije:\n\n• skenirane barkodove proizvoda\n• nazive proizvoda i detalje koje unosi korisnik\n• ocjene i komentare\n• popise za kupovinu\n• kategorije proizvoda\n• cijene i podatke o trgovinama\n• fotografije proizvoda i trgovina\n\nVaši podaci o proizvodima i fotografije ne šalju se na WasOK poslužitelje.",
    },
    permissions: {
      title: "Korištena dopuštenja",
      camera: {
        title: "Kamera",
        body: "Pristup kameri koristi se za:\n\n• skeniranje barkodova\n• snimanje fotografija proizvoda",
      },
      photos: {
        title: "Fotografije i mediji",
        body: "Pristup fotografijama ili galeriji koristi se samo kada:\n\n• prilažete slike proizvodima\n• vraćate sigurnosne kopije koje sadrže fotografije",
      },
      files: {
        title: "Pristup datotekama i pohrani",
        body: "Pristup datotekama može se koristiti za:\n\n• izvoz datoteka sigurnosnih kopija\n• uvoz sigurnosnih kopija koje odabere korisnik\n• dijeljenje popisa za kupovinu ili sigurnosnih kopija",
      },
    },
    backup: {
      title: "Značajke sigurnosnog kopiranja i izvoza",
      body: "WasOK omogućuje korisnicima stvaranje datoteka sigurnosnih kopija koje sadrže podatke aplikacije i po želji fotografije.\n\nDatoteke sigurnosnih kopija stvaraju se lokalno na vašem uređaju i mogu se pohraniti ili dijeliti putem usluga koje odabere korisnik, kao što su:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokalna pohrana uređaja\n\nWasOK ne šalje sigurnosne kopije na vlastite poslužitelje.",
      onlineProductLookup: {
        title: "Online pretraživanje proizvoda",
        body: "Kada u Postavkama omogućite online pretraživanje barkodova, WasOK može poslati samo skenirani broj barkoda javnim bazama proizvoda (poput Open Food Facts) kako bi predložio naziv proizvoda i marku. WasOK za ovu značajku ne šalje vaše ocjene, komentare, fotografije, popise za kupovinu, kategorije, podatke o trgovinama ni podatke sigurnosnih kopija. Ovu značajku možete isključiti u bilo kojem trenutku u Postavkama.",
      },
    },
    advertising: {
      title: "Oglašavanje i usluge trećih strana",
      intro:
        "WasOK koristi odabrane usluge trećih strana za pružanje određenih značajki.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob se koristi za prikaz oglasa unutar aplikacije.\n\nGoogle i njegovi partneri mogu obrađivati informacije kao što su:\n\n• identifikatori oglašavanja\n• podaci o uređaju\n• IP adresa\n• dijagnostički podaci i podaci o korištenju\n\nOd korisnika u određenim regijama može se zatražiti privola prije prikaza personaliziranih oglasa.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK koristi Firebase Crashlytics kako bi pomogao u prepoznavanju rušenja i poboljšanju stabilnosti aplikacije.\n\nIzvještaji o rušenju mogu uključivati tehničke informacije kao što su:\n\n• model uređaja\n• verzija operacijskog sustava\n• verzija aplikacije\n• dijagnostika rušenja\n\nIzvještaji o rušenju namjerno ne uključuju vaše ocjene proizvoda, bilješke, popise za kupovinu ni fotografije.",
      },
      externalProductDatabases: {
        title: "Vanjski katalogi proizvoda",
        body: "Funkcionalnost pretraživanja barkodova može koristiti vanjske baze proizvoda za dohvat informacija o proizvodu.\n\nZa više informacija pregledajte politike privatnosti odgovarajućih pružatelja.",
      },
    },
    dataSecurity: {
      title: "Sigurnost podataka",
      body: "WasOK pohranjuje podatke aplikacije lokalno na vašem uređaju koristeći mehanizme pohrane koje pruža operacijski sustav.\n\nIako se poduzimaju razumne mjere za zaštitu lokalnih podataka aplikacije, nijedna metoda elektroničke pohrane nije potpuno sigurna.\n\nKorisnici su odgovorni za održavanje sigurnosnih kopija važnih podataka ako to žele.",
    },
    children: {
      title: "Privatnost djece",
      body: "WasOK nije namijenjen djeci mlađoj od 13 godina.",
    },
    notifications: {
      title: "Obavijesti",
      body: "WasOK može po želji stvarati lokalne obavijesti na vašem uređaju kako bi vam podsjetio da ocijenite proizvode nakon kupnje.\n\nTe se obavijesti generiraju i zakazuju lokalno na vašem uređaju te ne zahtijevaju račun ni udaljeni poslužitelj.\n\nObavijesti možete onemogućiti u bilo kojem trenutku putem postavki uređaja ili unutar aplikacije, ako je podržano.",
    },
    yourControl: {
      title: "Vaša kontrola nad podacima",
      body: "Možete:\n\n• u bilo kojem trenutku uređivati ili brisati pohranjene proizvode\n• obrisati podatke aplikacije s uređaja\n• deinstalirati aplikaciju\n• izvesti sigurnosne kopije svojih podataka",
    },
    changes: {
      title: "Izmjene ove politike",
      body: "Ova politika privatnosti može se s vremena na vrijeme ažurirati.\n\nIzmjene stupaju na snagu kada se objavi ažurirana verzija.",
    },
    contact: {
      title: "Kontakt",
      body: "Ako imate pitanja u vezi s ovom politikom privatnosti, kontaktirajte:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Uvjeti korištenja",
    lastUpdated: "Posljednje ažuriranje: 1. lipnja 2026.",
    acceptance: {
      title: "Prihvaćanje uvjeta",
      body: "Preuzimanjem, instalacijom ili korištenjem WasOK-a pristajete na ove Uvjete korištenja.\n\nAko se ne slažete s ovim Uvjetima, ne biste trebali koristiti aplikaciju.",
    },
    license: {
      title: "Licenca",
      body: "WasOK vam daje ograničenu, neisključivu, neprenosivu i opozivu licencu za korištenje aplikacije u skladu s ovim Uvjetima.",
    },
    acceptableUse: {
      title: "Prihvatljivo korištenje",
      body: "Slažete se da nećete:\n\n• zloupotrebljavati aplikaciju\n• ometati rad aplikacije\n• pokušavati reverse engineering ili mijenjati aplikaciju\n• koristiti aplikaciju u suprotnosti s važećim zakonima ili propisima",
    },
    localData: {
      title: "Lokalni podaci i sigurnosne kopije",
      body: "WasOK pohranjuje korisničke podatke lokalno na uređaju.\n\nKorisnici su odgovorni za održavanje sigurnosnih kopija važnih podataka ako to žele.\n\nIako se može pružiti funkcionalnost sigurnosnog kopiranja i vraćanja, WasOK ne jamči zaštitu od gubitka, oštećenja ili kvara pohranjenih podataka.",
    },
    advertisements: {
      title: "Oglasi",
      body: "Aplikacija može prikazivati oglase koje pružaju partneri trećih strana za oglašavanje, uključujući Google AdMob.",
    },
    noWarranty: {
      title: "Bez jamstva",
      body: "WasOK se pruža „kakav jest“ i „kako je dostupan“ bez jamstava bilo koje vrste, izričitih ili podrazumijevanih.\n\nNe jamčimo da:\n\n• će aplikacija uvijek biti dostupna\n• će aplikacija biti bez grešaka\n• nikada neće doći do gubitka podataka\n• će sve značajke neprekidno funkcionirati na svim uređajima",
    },
    limitationLiability: {
      title: "Ograničenje odgovornosti",
      body: "U najvećoj mjeri dopuštenoj zakonom, WasOK i njegovi razvojni inženjeri neće biti odgovorni za:\n\n• gubitak podataka\n• gubitak dobiti\n• probleme s uređajem\n• neizravne ili posljedične štete\n• prekide koji proizlaze iz korištenja ili nemogućnosti korištenja aplikacije",
    },
    thirdParty: {
      title: "Usluge trećih strana",
      body: "Određene značajke ili sadržaj mogu ovisiti o uslugama trećih strana, uključujući pružatelje oglašavanja i vanjske usluge pohrane/dijeljenja koje odabere korisnik.\n\nWasOK nije odgovoran za usluge trećih strana ni njihove politike.",
    },
    productInformation: {
      title: "Informacije o proizvodima",
      body: "Određeni detalji o proizvodima mogu se dobiti od usluga trećih strana za pretraživanje barkodova.\n\nWasOK ne jamči točnost, potpunost, dostupnost ni prikladnost informacija koje pružaju vanjski izvori podataka.\n\nKorisnici bi trebali samostalno provjeriti informacije o proizvodima kada je to potrebno.",
    },
    changesApp: {
      title: "Izmjene aplikacije",
      body: "WasOK se može u bilo kojem trenutku izmijeniti, ažurirati, suspendirati ili ukinuti bez prethodne obavijesti.",
    },
    changesTerms: {
      title: "Izmjene ovih Uvjeta",
      body: "Ovi se Uvjeti mogu povremeno ažurirati.\n\nNastavak korištenja aplikacije nakon što ažuriranja stupe na snagu predstavlja prihvaćanje revidiranih Uvjeta.",
    },
    contact: {
      title: "Kontakt",
      body: "Za pitanja u vezi s ovim Uvjetima kontaktirajte:\n\nsupport@wasok.app",
    },
  },
};
